import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from 'react-apollo';
import { HelmetProvider } from 'react-helmet-async';

import { client } from './__graphql__/client';
import { App } from './App';

const Application = () => (
  <HelmetProvider>
    <ApolloProvider client={client}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ApolloProvider>
  </HelmetProvider>
);

ReactDOM.hydrate(<Application />, document.getElementById('root'));

if ((module as any).hot) {
  (module as any).hot.accept('./', function() {
    console.log('[HMR] module replaced');
  });
}
